import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get, update, remove } from '~/actions/containers';
import Spinner from '~/components/Spinner';
import LocationPicker from '~/components/LocationPicker';
import OrderPicker from '~/components/OrderPicker';
import NumericInput from 'react-numeric-input';
import Dropdown from 'react-toolbox/lib/dropdown';
import ArticlePicker from '~/components/ArticlePicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import DatePicker from '~/components/DatePicker';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const MultiArticlePicker = MultiPickerCount(ArticlePicker);

const types = [
  { value: 'box', label: 'Box' },
  { value: 'pallet', label: 'Pallet' },
  { value: 'letter', label: 'Letter' },
  { value: 'container', label: 'Shipping Container' },
];

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      container: null,
      changes: {},
    };
  }

  componentDidMount() {
    get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(r => this.setState({
        loading: false,
        container: r.data.container,
        changes: {}
      }))
      .catch(() => this.setState({ loading: false }));
  }

  submit() {
    return update(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id,
      this.state.changes
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    return remove(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  render() {
    if (this.state.loading) {
      return (
        <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            <Spinner />
          </div>
        </div>
      );
    }
    if (!this.state.loading && !this.state.container) {
      return (
        <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
          <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
            Not found
          </div>
        </div>
      );
    }
    const articleIds = (this.state.changes.articleIds !== undefined
      ? this.state.changes.articleIds
      : this.state.container.articleIds
    );
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Dropdown
                auto
                label="Container type"
                onChange={type => this.setState({ changes: { ...this.state.changes, type } })}
                source={types}
                value={this.state.changes.type !== undefined
                  ? this.state.changes.type
                  : this.state.container.type}
              />
              <div className={styleLocal.dimensions}>
                <div>Dimensions (meter)</div>
                <NumericInput
                  step={0.1}
                  min={0.01}
                  precision={2}
                  label="width"
                  snap
                  value={(this.state.changes.dimensions && this.state.changes.dimensions.width)
                    !== undefined
                    ? this.state.changes.dimensions.width
                    : this.state.container.dimensions && this.state.container.dimensions.width}
                  onChange={width => this.setState({
                    changes: {
                      ...this.state.changes,
                      dimensions: {
                        ...(this.state.changes.dimensions || this.state.container.dimensions || {}),
                        width,
                      },
                    }
                  })}
                  style={{ width: '80px' }}
                />
                &nbsp;x&nbsp;
                <NumericInput
                  step={0.1}
                  min={0.01}
                  precision={2}
                  label="height"
                  snap
                  value={(this.state.changes.dimensions && this.state.changes.dimensions.height)
                    !== undefined
                    ? this.state.changes.dimensions.height
                    : this.state.container.dimensions && this.state.container.dimensions.height}
                  onChange={height => this.setState({
                    changes: {
                      ...this.state.changes,
                      dimensions: {
                        ...(this.state.changes.dimensions || this.state.container.dimensions || {}),
                        height,
                      },
                    }
                  })}
                  style={{ width: '80px' }}
                />
                &nbsp;x&nbsp;
                <NumericInput
                  step={0.1}
                  min={0.01}
                  precision={2}
                  label="depth"
                  snap
                  value={(this.state.changes.dimensions && this.state.changes.dimensions.depth)
                    !== undefined
                    ? this.state.changes.dimensions.depth
                    : this.state.container.dimensions && this.state.container.dimensions.depth}
                  onChange={depth => this.setState({
                    changes: {
                      ...this.state.changes,
                      dimensions: {
                        ...(this.state.changes.dimensions || this.state.container.dimensions || {}),
                        depth,
                      },
                    }
                  })}
                  style={{ width: '80px' }}
                />
              </div>
              <div className={styleLocal.dimensions}>
                <div>Weight (kilo)</div>
                <NumericInput
                  step={0.1}
                  min={0.001}
                  precision={3}
                  label="weight"
                  snap
                  onChange={weight => this.setState({ changes: { ...this.state.changes, weight } })}
                  value={this.state.changes.weight !== undefined
                    ? this.state.changes.weight
                    : this.state.container.weight}
                  style={{ width: '80px' }}
                />
              </div>
              <div style={{ paddingBottom: '10px' }}>
                Location
                <LocationPicker
                  style={{ marginLeft: '20px' }}
                  value={this.state.changes.locationId !== undefined
                    ? this.state.changes.locationId
                    : this.state.container.locationId}
                  onChange={locationId =>
                    this.setState({ changes: { ...this.state.changes, locationId } })}
                />
              </div>
              <div style={{ paddingBottom: '10px' }}>
                Order
                <OrderPicker
                  style={{ marginLeft: '20px' }}
                  value={this.state.changes.orderId !== undefined
                    ? this.state.changes.orderId
                    : this.state.container.orderId}
                  onChange={orderId =>
                    this.setState({ changes: { ...this.state.changes, orderId } })}
                />
              </div>
              <div style={{ paddingBottom: '10px' }}>
                <span style={{ verticalAlign: 'top' }}>Shipping</span>
                <div style={{ display: 'inline-block', marginLeft: '20px' }}>
                  {(this.state.changes.shipping !== undefined
                    ? this.state.changes.shipping
                    : this.state.container.shipping
                  ) === null
                    ? <Button
                      label="Add shipping information"
                      primary
                      raised
                      onClick={() => this.setState({
                        changes: { ...this.state.changes, shipping: {} }
                      })}
                    />
                  : <div>
                    <div style={{ backgroundColor: '#0095ff', color: 'white', padding: '5px' }}>
                      <p>Shipping Provider</p>
                      <input
                        style={{ width: '100%' }}
                        type="text"
                        value={(this.state.changes.shipping && this.state.changes.shipping.id)
                          !== undefined
                          ? this.state.changes.shipping.id
                          : this.state.container.shipping && this.state.container.shipping.id}
                        onChange={e => {
                          const shipping = {
                            ...(this.state.container.shipping || {}),
                            ...(this.state.changes.shipping || {}),
                          };
                          shipping.id = e.target.value;
                          this.setState({ changes: { ...this.state.changes, shipping } });
                        }}
                      />
                      <p>Shipping Reference</p>
                      <input
                        style={{ width: '100%' }}
                        type="text"
                        value={(this.state.changes.shipping
                            && this.state.changes.shipping.reference) !== undefined
                          ? this.state.changes.shipping.reference
                          : this.state.container.shipping
                            && this.state.container.shipping.reference}
                        onChange={e => {
                          const shipping = {
                            ...(this.state.container.shipping || {}),
                            ...(this.state.changes.shipping || {}),
                          };
                          shipping.reference = e.target.value;
                          this.setState({ changes: { ...this.state.changes, shipping } });
                        }}
                      />
                      <p>Shipping Document Url</p>
                      <input
                        style={{ width: '100%' }}
                        type="text"
                        value={(this.state.changes.shipping && this.state.changes.shipping.uri)
                          !== undefined
                          ? this.state.changes.shipping.uri
                          : this.state.container.shipping && this.state.container.shipping.uri}
                        onChange={e => {
                          const shipping = {
                            ...(this.state.container.shipping || {}),
                            ...(this.state.changes.shipping || {}),
                          };
                          shipping.uri = e.target.value;
                          this.setState({ changes: { ...this.state.changes, shipping } });
                        }}
                      />
                    </div>
                    <Button
                      style={{ color: '#0095ff' }}
                      label="Remove shipping information"
                      onClick={() => this.setState({
                        changes: { ...this.state.changes, shipping: null }
                      })}
                    />
                  </div>}
                </div>
              </div>
              Article goal
              {(typeof articleIds === 'object' && articleIds !== null)
                ? <div>
                  <MultiArticlePicker
                    value={articleIds}
                    onChange={v =>
                      this.setState({ changes: { ...this.state.changes, articleIds: v } })}
                  />
                  <Button
                    label="Remove article goal"
                    primary
                    onClick={() => this.setState(
                      { changes: { ...this.state.changes, articleIds: null } })}
                    style={{ width: '100%' }}
                  />
                </div>
                : <div>
                  <Button
                    label="Set article goal"
                    className={styleLocal.buttonOutline}
                    style={{ width: '100%' }}
                    onClick={() => this.setState(
                      { changes: { ...this.state.changes, articleIds: {} } })}
                  />
                </div>}
              <br />
              <DatePicker
                label="ETA"
                locale="en"
                sundayFirstDayOfWeek
                value={
                  this.state.changes.eta ||
                  (this.state.container.eta ? new Date(this.state.container.eta) : null)
                }
                onChange={v => this.setState({ changes: { ...this.state.changes, eta: v } })}
                onDismiss={() =>
                  this.setState({
                    changes: { ...this.state.changes, eta: null },
                    container: { ...this.state.container, eta: null }
                  })
                }
              />
              <Button label="Save" icon="done" type="submit" primary raised />
              <Button
                className={styleLocal.buttonRemove}
                label="Delete"
                icon="clear"
                onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
              />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ContainerEdit/index.js